module.exports = __webpack_public_path__ + "static/media/brand.59ecf122.png";